"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Pagination = _interopRequireDefault(require("@insided/shared/uikit/Pagination"));

var _urlGenerator = require("@insided/deprecated-preact-components/utils/urlGenerator");

var _PrivateGroupPlaceholder = _interopRequireDefault(require("./PrivateGroupPlaceholder"));

var _TopicAdd = _interopRequireDefault(require("@insided/destination/icons/TopicAdd"));

var _common = require("@insided/shared/utils/common");

var _TopicListItemView = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicListItemView.sync"));

var _service = require("./service");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _mixpanelEventsFromDestination = require("@insided/deprecated-preact-components/utils/mixpanelEventsFromDestination");

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-topics-list';
exports.cssAnchorName = cssAnchorName;

var pageReload = function pageReload() {
  window.location.reload();
};

var GroupTopicsList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupTopicsList, _Component);

  var _super = _createSuper(GroupTopicsList);

  function GroupTopicsList() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupTopicsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      requestSent: _this.props.membershipStatus === 'requested'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "joinGroup", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(onSuccess) {
        var _this$props$group;

        var userId, isPrivateGroup, event, _this$props$group2, _this$props$group3;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
                isPrivateGroup = ((_this$props$group = _this.props.group) === null || _this$props$group === void 0 ? void 0 : _this$props$group.visibility) === _utils.GroupVisibility.Private;

                if (userId) {
                  _context.next = 6;
                  break;
                }

                event = new window.CustomEvent('GuestUserAction');
                window.dispatchEvent(event);
                return _context.abrupt("return");

              case 6:
                _this.setState({
                  isLoading: true
                });

                _context.prev = 7;
                _context.next = 10;
                return (0, _service.joinGroup)({
                  groupId: (_this$props$group2 = _this.props.group) === null || _this$props$group2 === void 0 ? void 0 : _this$props$group2.id,
                  csrfToken: _this.props.csrfToken
                });

              case 10:
                _this.setState({
                  isLoading: false
                });

                _publish.default.trackEvent('userevent', {
                  type: 'GroupMemberJoined',
                  payload: 'method1',
                  userId: userId,
                  addedBy: userId
                });

                if (onSuccess) {
                  onSuccess();
                }

                if (isPrivateGroup) {
                  (0, _mixpanelEventsFromDestination.trackRequestToJoinPrivateGroup)('RequestViaGroupDetailPage', (_this$props$group3 = _this.props.group) === null || _this$props$group3 === void 0 ? void 0 : _this$props$group3.id);
                }

                pageReload();
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](7);

                _this.setState({
                  isLoading: false
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 17]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "requestJoin", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.joinGroup(function () {
                _this.setState({
                  requestSent: true
                });
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return _this;
  }

  (0, _createClass2.default)(GroupTopicsList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          canSee = _this$props.canSee,
          topics = _this$props.topics,
          attachmentCdn = _this$props.attachmentCdn,
          totalPagesCount = _this$props.totalPagesCount,
          currentPage = _this$props.currentPage,
          isCurrentUserModerator = _this$props.isCurrentUserModerator;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          requestSent = _this$state.requestSent;
      var isFrontendModerationEnabled = _common.common.isModuleActive('frontendContentModeration') && isCurrentUserModerator;
      return (0, _preact.h)("div", {
        "data-bounded-context": "Groups",
        "data-entity": "group-topics-list"
      }, (0, _preact.h)("div", {
        className: "list-widget-wrapper"
      }, canSee && !!topics.length ? (0, _preact.h)("div", null, topics.map(function (topic) {
        return (0, _preact.h)(_TopicListItemView.default, {
          key: topic.privateId,
          topic: topic,
          attachmentCdn: attachmentCdn,
          hideCategoryMetadata: true,
          isFrontendModerationEnabled: isFrontendModerationEnabled
        });
      }), totalPagesCount > 1 ? (0, _preact.h)(_Pagination.default, {
        totalPageCount: totalPagesCount,
        currentPage: currentPage,
        generateNewUrl: _urlGenerator.generateNewUrl
      }) : null) : null, canSee && !topics.length ? (0, _preact.h)("div", {
        className: "group-private__placeholder groups-v2-styles"
      }, (0, _preact.h)("div", {
        className: "group-content-container"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_TopicAdd.default, {
        className: "icon-topic-add"
      }), (0, _preact.h)("h3", null, (0, _preact.h)(_phrase.default, {
        p: "groups.no.topics.yet"
      })), (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
        p: "groups.information.no.topics.description"
      }))))) : null, !canSee ? (0, _preact.h)(_PrivateGroupPlaceholder.default, {
        onRequest: this.requestJoin,
        isLoading: isLoading,
        requestPending: requestSent
      }) : null));
    }
  }]);
  return GroupTopicsList;
}(_preact.Component);

var _default = GroupTopicsList;
exports.default = _default;